import React from 'react';

const ScrollableElement = ({onScroll, children}) => (

<div onScroll={onScroll} className="scrollable-element">{children}</div>
)

export default ScrollableElement;